import * as tslib_1 from "tslib";
import { Component, Prop, Watch } from "vue-property-decorator";
import { H3Org } from "h3-mobile-vue";
import { StaffSelectorBase } from '../staff-selector-base';
import ControlBack from '@cloudpivot/form/src/common/directives/control-back';
let MobileStaffSelector = class MobileStaffSelector extends StaffSelectorBase {
    constructor() {
        super(...arguments);
        this.showModal = false;
    }
    updateShow(val) {
        if (val) {
            this.show();
        }
        else {
            this.close();
        }
    }
    show() {
        this.showModal = true;
    }
    close() {
        this.showModal = false;
    }
    created() {
        // super.treeFocus();
    }
    // 【ID1006424】云枢v6.1.3移动端选人控件映射关系失效
    mounted() {
        // Array.isArray(this.selected) && this.selected.length;
    }
    treeFocus() {
        super.treeFocus();
    }
    // 删除选中
    delect(val) {
        this.selected = this.selected.filter((i) => i.key !== val.key);
        super.onChange(this.selected);
    }
    // 树-返回
    onClickTrunBack() {
        super.onClickTrunBack();
    }
    // 树-下一级
    onClickNextHierarchy(val) {
        super.onClickNextHierarchy(val);
    }
    onClickBreadcrumb(val) {
        super.onClickBreadcrumb(val);
    }
    onChange(items) {
        super.onChange(items);
    }
    onOk(items) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // console.log(items);
            _super("onOk").call(this, items);
        });
    }
    onCancle() {
        super.onCancle();
    }
    onSearch(name) {
        clearTimeout(this.searchTaskRef);
        this.searchTaskRef = setTimeout(() => {
            super.onSearch(name);
        }, 500);
    }
    onReadonlyChange(v) {
        setTimeout(() => {
            const h3Org = this.$refs.h3Org;
            if (h3Org && h3Org.getContentHeight) {
                h3Org.getContentHeight();
            }
        });
    }
};
tslib_1.__decorate([
    Prop({
        default: ''
    })
], MobileStaffSelector.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], MobileStaffSelector.prototype, "required", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], MobileStaffSelector.prototype, "readonlyFormula", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], MobileStaffSelector.prototype, "readonly", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({})
    })
], MobileStaffSelector.prototype, "labelStyle", void 0);
tslib_1.__decorate([
    Watch('readonly')
], MobileStaffSelector.prototype, "onReadonlyChange", null);
MobileStaffSelector = tslib_1.__decorate([
    Component({
        name: "mobile-staff-selector",
        components: {
            H3Org
        },
        directives: {
            ControlBack,
        },
        model: {
            event: "change",
            prop: "value"
        }
    })
], MobileStaffSelector);
export default MobileStaffSelector;
